import { PostRateDefaultFactorTypeSearchRequestQuery } from '@lio/api-types';

export const postRateDefaultFactorTypeKeys = {
  search: ['post-rate-default-factor-type'] as const,
  searchWithParams: (params: PostRateDefaultFactorTypeSearchRequestQuery) =>
    [...postRateDefaultFactorTypeKeys.search, params] as const,
};
